import { Component, Input } from "@angular/core";
import { VehicleType } from "@app/enum/VehicleType.enum";
import { IPeripheral, IUnit } from "@app/interfaces/IPeripheral";
import { IEngineerCommission, IValidationCheck } from "@app/main/modules/foundation/foundation.interfaces";
import './commission-summary.component.scss';


@Component({
    selector: 'commission-summary',
    template: require('./commission-summary.component.html')
})
export class CommissionSummaryComponent {
    @Input() commission: IEngineerCommission;
    @Input() commissionChecks: IValidationCheck[];

    installedDevices: (IPeripheral | IUnit)[];
    VehicleType = VehicleType;


    constructor() { }

    ngOnInit(): void {
    }


}
